import React, { useState, useEffect,useRef} from 'react';
import { useLocation, useNavigate,Link } from 'react-router-dom';
import { fetchCourseDetails, learnVideo,createComment,deleteCommentAPI,uploadFileAPI ,TakeSpecialScoreAPI,fetchUserScore} from '../services/userApi'; // ปรับเส้นทางให้ตรงกับที่คุณเก็บ API
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faCalendar, faClock,} from '@fortawesome/free-regular-svg-icons';
import {faXmark,faCheck ,faDownload,faCircleChevronUp,faCircleChevronDown, faChevronRight} from '@fortawesome/free-solid-svg-icons';

import VideosTab from '../components/VideosTab.jsx';
import DocumentList from '../components/DocumentList.jsx';
import TestList from '../components/TestList.jsx'; 
import CommentsTab from '../components/CommentsTab.jsx'; 
import HomeworksTab from '../components/HomeworksTab.jsx';  
import SpecialScoreTab from '../components/SpecialScoreTab.jsx'; 
import SurveyTab from '../components/SurveyTab.jsx'; 
import AccountCoursesTab from '../components/AccountCoursesTab.jsx'; 

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import backgroundImage2 from '../assets/bg2.jpg';
import backgroundImage from '../assets/Frame_67.jpg';
import close from '../assets/close.png';  


const CoursePage = () => {
    const account = JSON.parse(localStorage.getItem("account"));
    const isAdmin = account?.is_admin === 1; // ตรวจสอบว่า is_admin เป็น 1 หรือไม่

    const location = useLocation();
    const MySwal = withReactContent(Swal);
    const [courseDetails, setCourseDetails] = useState(null);
    const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
    const currentVideo = courseDetails?.videos?.[currentVideoIndex];
    const { activeTab } = location.state || {}; // รับค่าจาก state

    const [currentActiveTab, setActiveTab] = useState(activeTab); // ใช้ activeTab จาก state
   
    const navigate = useNavigate();
    const course_uid = location.state?.courseUid; // ดึง course_uid จาก state ที่ถูกส่งมา
    const accessToken = JSON.parse(localStorage.getItem('account'))?.access_token;
    const [user, setUser] = useState(null);
    //comment
    const [newComment, setNewComment] = useState('');
    const [replyToCommentUid, setReplyToCommentUid] = useState(null);
    const [replyMessage, setReplyMessage] = useState(''); // ใช้เก็บข้อความตอบกลับ    
    const accountUid = JSON.parse(localStorage.getItem('account'))?.uid;
    //surveys
    const [isModalOpen, setIsModalOpen] = useState(false); // State สำหรับการเปิดปิดโมดัล

    // course metadata
    const metadata = JSON.parse(localStorage.getItem('courseData'));
    const courseNameCreateData = [ ...metadata.course_names ];    
    const categoryCreateData = [ ...metadata.categorys ];
    const subjectCreateData = [ ...metadata.subjects ];
    const yearCreateData = [ ...metadata.years ];  
    const generationCreateData = [ ...metadata.generations ];  

    //homework
    const [downloadedFiles, setDownloadedFiles] = useState({});
    const fileInputRef = useRef(null);
    //responsive
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1025);
    
    const handleResize = () => {
        setIsSmallScreen(window.innerWidth < 1025);
    };
       // สถานะสำหรับควบคุม Popup
    const [isPopup1Open, setIsPopup1Open] = useState(false);
    const [isPopup2Open, setIsPopup2Open] = useState(false);
    const [coursesData, setCoursesData] = useState([]);

    useEffect(() => {
        if (course_uid && accessToken) {
            fetchData(course_uid, accessToken); // เรียก fetchData เมื่อ course_uid และ accessToken มีค่า
        }
        fetchUserData();

        // จัดการการเลื่อนของ body ตามสถานะของ Modal
        document.body.style.overflow = isModalOpen ? 'hidden' : 'auto';

        // ติดตั้ง event listener สำหรับการเปลี่ยนขนาดหน้าจอ
        window.addEventListener('resize', handleResize);

        // ฟังก์ชันคืนค่า
        return () => {
            document.body.style.overflow = 'auto'; // คืนค่าการเลื่อนเมื่อคอมโพเนนต์ถูกถอดออก
            window.removeEventListener('resize', handleResize); // ลบ event listener
        };

    }, [course_uid, accessToken, isModalOpen]);
    
    //Swal
    const onError = (title, response) => { 
        MySwal.fire({
            title: title,
            html: response?.data?.error?.message,
            icon: "error",
            confirmButtonText: "Close",
            allowOutsideClick: false,
        }).then(async (result) => {
          if (result.isConfirmed) {
              if (response?.status === 401) {
                  sessionStorage.removeItem('hasVisited');
                  sessionStorage.removeItem('lastPath');        
                  localStorage.removeItem('account');                  
                  navigate('/');
              }
          }
        });
    };
    
    const onSuccess = (title, message) => {
        MySwal.fire({
            icon: 'success',
            title: title,
            text: message,
            confirmButtonText: 'กลับสู่หน้าบทเรียน',
            confirmButtonColor: '#44526E',
            allowOutsideClick: false,
        });
    };
    
    const onWarning = () => {
        MySwal.fire({
            title: 'คุณเคยทำแบบสอบถามนี้แล้ว',
            text: 'คุณไม่สามารถทำแบบสอบถามนี้ได้อีก',
            icon: 'warning',
            confirmButtonText: 'ปิด',
            allowOutsideClick: false,
        });
    };

    const getNameCourseNameMetadata = (id) => { return courseNameCreateData.find(item => item.id === id).name || ''; };
    const getNameCagegoryMetadata = (id) => { return categoryCreateData.find(item => item.id === id).name || ''; };
    const getNameSubjectMetadata = (id) => { return subjectCreateData.find(item => item.id === id).name || ''; };  
    const getNameYearMetadata = (id) => { return yearCreateData.find(item => item.id === id).name || ''; };  
    const getNameGenerationMetadata = (id) => { return generationCreateData.find(item => item.id === id).name || ''; };  
        
    //Api ดึงข้อมูลคอร์ส
    const fetchData = async () => {
            try {
                await fetchCourseDetails(course_uid, accessToken)
                    .then(response => {
                        const course = response.data?.course || {};
                        const user = response.data?.user || [];
                        const videos = response.data?.videos || [];
                        const documents = response.data?.documents || [];
                        const tests = response.data?.tests || [];
                        const others = response.data?.surveys || [];
                        const homeworks = response.data?.homeworks || [];
                        const specials = response.data?.specials || [];
                        const comments = response.data?.comments || [];
                        const account_courses = response.data?.account_courses || [];
    
                        setCourseDetails({
                            course,
                            user,
                            videos,
                            documents,
                            tests,
                            others,
                            homeworks,
                            specials,
                            comments,
                            account_courses
                        });
    
                        setCurrentVideoIndex(0); // ตั้งค่า video แรกที่ต้องการแสดง
                    });
            } catch (error) {
                console.error('Error fetching course details:', error);
            }
    };

    

    //Api ดึงชื่อมาtop bar (Profile)
    const fetchUserData = async () => {
        try {
            const userData = JSON.parse(localStorage.getItem('account'));
            if (userData) {
                setUser(userData);
            }
        } catch (error) {
            console.error('Failed to fetch user data:', error);
        }
    };


        // ฟังก์ชันสำหรับเปิด Popup ตัวที่ 1
        const openPopup1 = () => {
        setIsPopup1Open(true);
        };

        // ฟังก์ชันสำหรับเปิด Popup ตัวที่ 2
        const openPopup2 = () => {
        setIsPopup2Open(true);
        };

       // ฟังก์ชันหลัก ShowScoreAll
        const ShowScoreAll = async (course_name, category, generation, popupType) => {
            try {
                // เรียกใช้ fetchUserScore เพื่อดึงข้อมูลจาก API
                const data = await fetchUserScore(course_name, category, generation);

                // แสดงข้อมูลที่ได้รับจาก API เพื่อการตรวจสอบ
                console.log("Response data:", data);

                // ตรวจสอบข้อมูลและจัดการ state
                if (data && data.status === true && data.data && data.data.account_course && Array.isArray(data.data.account_course.courses)) {
                    setCoursesData(data.data.account_course.courses);
                    
                    // แสดงข้อมูลใน console
                    const courses = data.data.account_course.courses;
                    courses.forEach(course => {
                        console.log("Course Name:", course.name);
                        course.categorys.forEach(category => {
                            console.log("Category:", category.category);
                            category.subjects.forEach(subject => {
                                console.log("Subject:", subject.subject);
                                console.log("Test Total Score Sum:", subject.test_total_score_sum, "Test Max Score Sum:", subject.test_max_score_sum);
                                console.log("Homework Total Score Sum:", subject.homework_total_score_sum, "Homework Max Score Sum:", subject.homework_max_score_sum);
                                console.log("Special Total Score Sum:", subject.special_total_score_sum, "Special Max Score Sum:", subject.special_max_score_sum);
                            });
                        });
                    });

                    // เปิด Popup ตามประเภทที่ส่งมา หากข้อมูลถูกต้อง
                    if (popupType === 1) {
                        openPopup1();
                    } else if (popupType === 2) {
                        openPopup2();
                    }

                } else {
                    console.error("ไม่พบข้อมูลหลักสูตร");
                    setCoursesData([]); // กรณีไม่พบข้อมูลหรือข้อมูลไม่ถูกต้อง

                    // แสดงข้อความเตือนด้วย SweetAlert
                    Swal.fire({
                        icon: 'warning',
                        title: 'คุณไม่ได้อยู่ในหลักสูตรนี้',
                        text: 'กรุณาติดต่อทางแอดมินเพื่อเพิ่มรายชื่อเข้าหลักสูตร'
                    });
                }
            } catch (err) {
                console.error("Error fetching data:", err);
                setCoursesData([]); // กรณีเกิดข้อผิดพลาดจากการดึงข้อมูล

                // แสดงข้อความเตือนด้วย SweetAlert
                Swal.fire({
                    icon: 'warning',
                    title: 'แจ้งเตือน',
                    text: 'เกิดข้อผิดพลาดในการดึงข้อมูล'
                });
            }
        };


    // ฟังก์ชันเพื่อปิด popup ทั้งหมด
    const closePopup = () => {
        setIsPopup1Open(false); // ปิด popup1
        setIsPopup2Open(false); // ปิด popup2
    };
  

    //Api Comment
    const createCommentApi = async (courseUid, replyCommentUid, message) => { 
        try {
            const result = await createComment(courseUid, replyCommentUid, message);     
            if (result.status === true) {
                // เรียกใช้งาน fetchUserData อีกครั้งเพื่ออัพเดทข้อมูล
                await fetchData();
            } else {
                throw new Error("Cannot create comment. Please try again");
            }
        } catch (error) {            
            // ปรับปรุงการจัดการข้อผิดพลาด
            const errorMessage = error?.response?.data?.message || "An unexpected error occurred";
            onError("Create comment error", errorMessage);
        }
    };
      

    // Api Delete Comment
    const deleteCommentApi = async (commentUid) => {
        try {
            const result = await deleteCommentAPI(commentUid);
            if (result.status === true) {
                await fetchData();  // อัปเดตข้อมูลหลังจากลบ
            } else {
                throw new Error("Cannot delete comment. Please try again");
            }
        } catch (error) {            
            onError("Delete comment error", error?.response);
        }
    };

    // Api Delete Reply
    const deleteReplyApi = async (replyUid) => {
        try {
            const result = await deleteCommentAPI(replyUid);  // เรียกฟังก์ชัน API สำหรับลบ reply
            if (result.status === true) {
                await fetchData();  // อัปเดตข้อมูลหลังจากลบ
            } else {
                throw new Error("Cannot delete reply. Please try again");
            }
        } catch (error) {            
            onError("Delete reply error", error?.response);
        }
    };
   
    //video
    const handleVideoEnd = async () => {
        if (courseDetails?.videos && courseDetails.videos[currentVideoIndex]) {
            const currentVideo = courseDetails.videos[currentVideoIndex];
            const accessToken = JSON.parse(localStorage.getItem('account'))?.access_token;
    
            if (currentVideo && accessToken) {
                // ตรวจสอบว่าความรู้เกี่ยวกับวิดีโอนั้นยังไม่ถูกทำเครื่องหมาย
                if (!currentVideo.is_learned) {
                    try {
                        // เรียกใช้ฟังก์ชัน learnVideo
                        const result = await learnVideo(courseDetails.course.uid, currentVideo.uid, accessToken);
                        console.log('LearnVideo Result:', result); // ตรวจสอบผลลัพธ์ที่นี่
    
                        // อัปเดตสถานะวิดีโอ
                        setCourseDetails(prev => {
                            console.log('Previous Course Details:', prev); // ตรวจสอบค่าก่อน
                            const updatedVideos = prev.videos.map((video, index) =>
                                index === currentVideoIndex ? { ...video, is_learned: true } : video
                            );
                            console.log('Updated Videos:', updatedVideos); // ตรวจสอบค่าหลังการอัพเดต
    
                            return {
                                ...prev,
                                videos: updatedVideos
                            };
                        });
                        onSuccess('สำเร็จ', 'คุณเรียนรู้วิดีโอนี้แล้ว');
                    } catch (error) {
                        console.error('Error marking video as learned:', error);
                        onError("Login error", error?.response || { data: { error: { message: 'An unexpected error occurred' } } });
                    }
                } else {
                    console.log('Video already marked as learned.');
                }
            } else {
                console.warn('No current video or access token available.');
            }
        } else {
            console.warn('No video details available.');
        }
    };
    
    const handleVideoClick = (index) => {
        setCurrentVideoIndex(index);
        
    };

    const handleTabChange = (tabName) => {
        setActiveTab(tabName);
    };

   const handleTestClick = (test_uid) => {
    const test = courseDetails.tests.find(test => test.uid === test_uid);
    
    if (test) {
        if (test.is_tested === 1) {
            // ถ้า is_tested เป็น 1 แสดงข้อความว่าได้ทำการสอบแล้ว
            Swal.fire({
                title: 'คุณได้ทำการสอบไปแล้ว',
                icon: 'warning',
                confirmButtonText: 'ตกลง'
            });
        } else {
            // ถ้า is_tested เป็น 0 นำทางไปยังหน้า Test
            navigate('/Test', { state: { testUid: test.uid, courseUid: test.course_uid } });
        }
    } else {
        console.error('Test not found');
    }
};
    
const handleDownload = (fileUrl) => {
    // อัปเดตสถานะการดาวน์โหลด
    setDownloadedFiles(prev => ({ ...prev, [fileUrl]: true }));
};

    //comment   
    const toggleReply = (commentUid) => {
        setReplyMessage('');
        setReplyToCommentUid(prev => (prev === commentUid ? null : commentUid));
    };    
    const handleReplySubmit = async (event, commentUid) => {
        event.preventDefault();
        if (replyMessage.trim()) {
            await createCommentApi(course_uid, commentUid, replyMessage);
            setReplyMessage('');
            setReplyToCommentUid(null);            
        } else {
            onError('ข้อผิดพลาด', 'กรุณากรอกข้อความความคิดเห็น');
        }
    };    
    const handleReplyChange = (event) => {
        setReplyMessage(event.target.value);
    };    
    const handleCommentChange = (event) => {
        setNewComment(event.target.value);
    };    
    const handleCreateComment = async (event) => {
        event.preventDefault();
        if (newComment.trim()) {
            await createCommentApi(course_uid, null, newComment);
            setNewComment('');
            //setReplyToCommentUid(null);            
        } else {
            onError('ข้อผิดพลาด', 'กรุณากรอกข้อความความคิดเห็น');
        }
    };      
    const handleDeleteComment = async (event, uid, isReply = false) => {
        const title = isReply ? "ลบ ความคิดเห็นย่อย" : "ลบ ความคิดเห็นหลัก";
        const text = isReply ? "คุณต้องการจะลบความคิดเห็นย่อยนี้ใช่หรือไม่?" : "คุณต้องการจะลบความคิดเห็นนี้ใช่หรือไม่?";
        const confirmButtonText = isReply ? "ลบความคิดเห็นย่อย" : "ลบความคิดเห็นหลัก";
    
        MySwal.fire({
            title: title,
            text: text,
            showCancelButton: true,
            confirmButtonColor: "#C91515",
            confirmButtonText: confirmButtonText,
            cancelButtonText: "ยกเลิก",
            reverseButtons: true,
            allowOutsideClick: false,
        }).then(async (result) => {
            if (result.isConfirmed) {
                if (isReply) {
                    await deleteReplyApi(uid);  // ลบความคิดเห็นย่อย
                } else {
                    await deleteCommentApi(uid);  // ลบความคิดเห็นหลัก
                }
            }
        });
    };
      

    //แปลงเวลา
    const convertTimeFormat = (timeStr) => {
        let [time, modifier] = timeStr.split(' ');
        let [hours, minutes] = time.split(':');

        if (hours === '12') {
            hours = '00';
        }

        if (modifier === 'PM') {
            hours = parseInt(hours, 10) + 12;
        }

        return `${hours}:${minutes}`;
    };

    //surveys
    const handleChapterClick = (survey_uid) => {
        const survey = courseDetails.others.find(item => item.uid === survey_uid);
        if (survey) {
            if (survey.is_surveyed === 1) {
                // ถ้า is_tested เป็น 1 แสดงข้อความว่าได้ทำการสอบแล้ว
                Swal.fire({
                    title: 'คุณได้ทำการสอบไปแล้ว',
                    icon: 'warning',
                    confirmButtonText: 'ตกลง'
                });
            } else {
                // ถ้า is_tested เป็น 0 นำทางไปยังหน้า Test
                navigate('/survey', { state: { surveyUid: survey.uid, courseUid: survey.course_uid } });
            }
        } else {
            console.error('Test not found');
        }
        };
    
        const convertToThaiDate = (dateString) => {
            const months = [
                'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
                'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
            ];
            
            const date = new Date(dateString); // แปลงเป็น Date object
            const day = date.getDate(); // วัน
            const month = months[date.getMonth()]; // เดือน
            const year = date.getFullYear() + 543; // ปี พ.ศ.
        
            // คืนค่าเป็นรูปแบบ วัน เดือน ปี พ.ศ.
            return `${day} ${month} ${year}`;
        };
    
    const handleUpload = async (homework_uid) => {
        // ตรวจสอบว่า fileInputRef และ fileInputRef.current ถูกกำหนด
        if (!fileInputRef.current) {
            alert("ไม่พบช่องทางการอัพโหลดไฟล์");
            return;
        }
    
        const files = fileInputRef.current.files;
    
        if (files.length === 0) {
            alert("กรุณาเลือกไฟล์ก่อนอัพโหลด");
            return;
        }
    
        const filesArray = Array.from(files);
    
        try {
            const result = await uploadFileAPI(homework_uid, filesArray);
            console.log('Upload success:', result);
    
            // แสดง SweetAlert
            Swal.fire({
                title: 'สำเร็จ',
                text: 'อัพโหลดการบ้านแล้ว',
                icon: 'success',
                confirmButtonText: 'กลับสู่หน้าบทเรียน',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    setActiveTab('homeworks');
                    await fetchData();
                }
            });
    
        } catch (error) {
            console.error('Upload failed:', error);
            alert('เกิดข้อผิดพลาดในการอัพโหลด: ' + error.message);
        }
    };
        const handleUploadScore = async (special_uid) => {
        const files = fileInputRef.current.files;
    
        if (files.length === 0) {
            alert("กรุณาเลือกไฟล์ก่อนอัพโหลด");
            return;
        }
    
        const filesArray = Array.from(files);
    
        try {
            const result = await TakeSpecialScoreAPI(special_uid, filesArray);
            console.log('Upload success:', result);
    
            // กำหนดค่า title และ message ที่จะใช้ใน SweetAlert
            const title = 'สำเร็จ';
            const message = 'อัพโหลดคะแนนพิเศษแล้ว';
    
            // แสดงป๊อปอัพ SweetAlert
            Swal.fire({
                title: title,
                text: message,
                icon: 'success',
                showCancelButton: false,
                confirmButtonText: 'กลับสู่หน้าบทเรียน',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    // เมื่อกดปุ่ม 'กลับสู่หน้าบทเรียน'
                    setActiveTab('specialscore'); // เปลี่ยน activeTab เป็น 'homeworks'
    
                    // เรียกฟังก์ชันสำหรับดึงข้อมูลใหม่จาก API
                    await fetchData(); // ฟังก์ชันนี้ควรเป็นฟังก์ชันที่ใช้ดึงข้อมูล homework ใหม่จาก API
                }
            });
    
        } catch (error) {
            console.error('Upload failed:', error);
            alert('เกิดข้อผิดพลาดในการอัพโหลด: ' + error.message);
        }
    };

    const isHomeworkExpired = (datetime) => {
        const now = new Date(); // เวลาปัจจุบัน
        const deadlineDate = new Date(datetime); // วันที่หมดอายุ
        return now > deadlineDate; // คืนค่า true ถ้าหมดอายุ
    };
    
    const styles = {
        background: {
            position: 'fixed',
            width: '100%',
            height: '100%',
            top: '0',
            left: '0',
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            zIndex: '-1',
        },  
        majorRoomYear:{
            display:'flex',
            gap:'16px',
            fontSize:'16px'
        },
        teacherDateTime:{
            display:'flex',
            gap:'24px',
            width:'60%',
            margin:'20px 0'
        },
        infoTimeline: {
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'flex-start', // เปลี่ยนจาก 'center' เป็น 'flex-start'
            margin: '10px 0',
            background: '#6B7280',
            padding: '8px 24px',
            borderRadius: '18px',
        },
        progressContainer: {
            width: '100%',
            backgroundColor: '#F9FAFB',
            borderRadius: '64px',
            overflow: 'hidden',
            maxWidth:'367px',
            height: '8px',
            border:'1px solid #dddddd'
        },
        progressBar: {
            height: '8px',
            backgroundColor: '#44526E',
            width: '0%', // เริ่มต้นที่ 0%
        },
        modalStyles: {
            content: {
                position: 'absolute',
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                transform: 'translate(-50%, -50%)',
                maxHeight: '80%', // ปรับสูงสุดให้พอดีกับหน้าจอ
                overflowY: 'hidden', // เลื่อนเนื้อหาภายใน modal
                backgroundColor: 'rgba(199,199,199,0.9)',
                borderRadius: '20px',
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                maxWidth: '800px',
                width: '100%',
                boxSizing: 'border-box',
                padding:'0'
            },
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.5)', // พื้นหลังโปร่งแสง
                zIndex: 9999,
            },
        },
        container: {
            overflowY: 'auto',  // เลื่อน scroll bar ใน container
            overflowX: 'hidden',
            boxSizing: 'border-box',
            height: '100%',  // ความสูงของ container เต็ม
            maxHeight: '80vh', // กำหนดความสูงสูงสุดของ container ให้พอดีกับหน้าจอ (ใช้ vh เพื่อให้สัมพันธ์กับหน้าจอ)
            padding: '10px', // เพิ่ม padding เพื่อให้เนื้อหามีพื้นที่ห่างจากขอบ
        },
        sectionContainer: {
            padding: '10px',          // ระยะห่างภายในกรอบ
        },    
        sectionTitle: {
            fontSize: '24px',
            margin: '10px 0',
            wordWrap: 'break-word', // ตัดบรรทัดเมื่อคำยาวเกินไป
            whiteSpace: 'normal',   // อนุญาตให้ตัดบรรทัด
            overflow: 'hidden',     // ซ่อนข้อความที่เกินพื้นที่
        },
        optionTextRow: {
            display: 'flex',     // จัดให้ radio buttons เรียงในแนวนอน
            justifyContent: 'space-between',
            width: '100%',       // ครอบคลุมพื้นที่ทั้งหมด
            padding:'10px',
            boxSizing:'border-box',

        },
        optionText: {
            width: '40px', // กำหนดความกว้างให้กับ option text
            textAlign: 'center', // จัด text ให้อยู่ตรงกลางในแต่ละช่อง
            fontSize:'16px',
           boxSizing:'border-box'
        },
        questionRow: {
            display: 'flex', // จัดคำถามกับ radio buttons ให้อยู่ในแนวนอน
            alignItems: 'center', // จัดให้อยู่ตรงกลางแนวตั้ง
        },
        radioButtonsRow: {
            display: 'flex',     // จัดให้ radio buttons เรียงในแนวนอน
            justifyContent: 'space-between',
           width: '100%',       // ครอบคลุมพื้นที่ทั้งหมด
           gap:'32px',
          fontSize:'24px'
        },
        radioWrapper: {
          
          alignItems:'center'
        },
        questionAndRadioContainer:{
            display : 'flex',

        },
        textArea:{
            width:'100%',
            border:'none',
            boxSizing:'border-box',
            height:'150px',
            resize: 'vertical',
            padding:'20px',
            fontSize:'16px',
            borderRadius:'20px',
            background:'white'
        },
        submitButton:{
            width:'100%',
            height:'64px',
            borderRadius:'64px',
            background:'#44526e',
            boxShadow: '0px 4px 42px 0px #001D6740',
            border:'none',
            fontSize:'24px',
            color:'white',
            cursor:'pointer',
           
        },
        bgContainer:{
            backgroundColor: 'rgba(255,255,255,0.8)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            boxShadow: '0px 4px 42px 0px #00000040',
            boxSizing:'border-box',
            borderRadius:'36px',
            margin:'24px',
        },
        bottomPanel:{
            backgroundColor: '#f2f2f2',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            padding:'42px',
            borderRadius:'36px',
            marginTop:'20px',
            boxSizing:'border-box',
            border:'1px solid #cccccc'
        },
        left:{
            textAlign:'left',
            width:'60%',
        },
        right:{
            background:'white',
            border:'1px solid #dddddd',
            width:'30%',
            padding:'24px',
            borderRadius:'16px',
            textAlign:'left'
        },
        rightScore:{
            width:'30%',
            textAlign:'left'
        },
        allScore:{
            background:'white',
            border:'1px solid #dddddd',
            borderRadius:'16px',
            textAlign:'left',
            padding:'24px',  
            marginBottom:'16px'
        },
        btnScore:{
            width:'100%',
            marginBottom:'16px',
            borderRadius:'1000px',
            border:'1px solid #44526e',
            background:'white',
            color:'#44526e',
            fontWeight:'bold',
            cursor:'pointer'
        },
        detailCourse:{
            width:'100%',
            display:'flex',
            boxSizing:'border-box',
            gap:'24px',
            justifyContent:'space-between',
        },
        downloadHW:{
            border:'1px solid #dddddd',
            borderRadius:'16px',
            padding:'24px',
            height:'241px',
            maxHeight: '241px', overflowY: 'auto',
        },
        commentcontainer:{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            boxSizing: 'border-box',  // ใช้ boxSizing: 'border-box' เพื่อรวม padding และ border เข้าไปในขนาดรวม
            padding: 0,  // กำหนดให้ไม่มี padding
            margin: 0,   // กำหนดให้ไม่มี margin
        },
        Detaildatteachtime:{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center', 
            justifyContent: 'center', 
            backgroundColor: '#f2f2f2',
            width: '100%',
            height: 'auto',
            padding: '24px',
            borderRadius:'15px',
            color:'#44526e',
            fontSize:'16px',
            textAlign:'center',
            boxSizing:'border-box',
            border:'1px solid #dddddd',
            gap:'10px'
        },

          modalStyles: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000, // เพื่อให้ Modal อยู่เหนือส่วนอื่นๆ
          },
          modalContentStyles: {
            backgroundColor: 'white',
            borderRadius: '36px',
            width: '50%',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            textAlign: 'center',
            boxSizing: 'border-box'
          },
          headerScorePopup:{
            display:'flex',
            justifyContent:'space-between',
            borderBottom:'1px solid black',
            alignItems:'center',
            padding:'20px',
            boxSizing: 'border-box'
          },
          closeBtn:{
            width:'5%',
            cursor:'pointer'
          },
          thrStyle: {
            backgroundColor: "#44526e", color: "white",textAlign:'center',fontSize:'1vw'
          },
          thStyle: {
            padding: '10px',
            boxSizing: 'border-box',
            whiteSpace: 'nowrap',  /* ป้องกันการตัดบรรทัด */
            overflow: 'hidden',    /* ซ่อนข้อความที่ล้นออกมา */
            textOverflow: 'ellipsis'  /* ใส่ "..." เมื่อข้อความยาวเกิน */
        },
        
          tdrStyle: {
            backgroundColor: "white", color: "black"
          },
          tdStyle: {
            padding: "10px",
            fontFamily: 'Kanit, sans-serif',
            overflow: 'hidden',    /* ซ่อนข้อความที่ล้นออกมา */
            textOverflow: 'ellipsis',  /* ใส่ "..." เมื่อข้อความยาวเกิน */
            fontSize: '1vw'
        },
        
          tdStyleNumber:{
            padding: "10px",        
            fontFamily: 'Kanit, sans-serif',
            whiteSpace: 'nowrap',
            textAlign:'center',
            fontSize:'1vw'
          },
          tableStyle:{
            padding:'10px 40px',
            boxSizing:'border-box',
          },
          headText:{
            margin:0,
            paddingRight:'10px',
            textAlign:'left'
          }
    }
    
    return (
    <>
        <div style={styles.background}></div>
        <main style={{ 
            marginTop: '90px',
            position: 'relative',
            overflow: 'hidden',
        }}>
            <div id="video-player">
                {currentVideo ? (
                    <video
                        key={currentVideo.uid}
                        controls
                        onEnded={handleVideoEnd}
                        style={{ 
                            width: '100%', 
                            maxHeight: '650px',
                            background:'black'
                        }}
                    >
                        <source src={currentVideo.url} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                ) : (
                    <div className="video-item inactive">
                       
                    </div>
                )}
            </div>
            <div style={styles.bgContainer}>
                <div  style={{
                    width: '100%',
                    display: 'block',
                    flexDirection: 'column' ,
                    position: 'relative',
                    boxSizing:'border-box',
                    wordWrap: 'break-word',
                    padding:'24px'
                }} >
                {courseDetails ? (
                    <div style={{
                        display: 'flex', // ใช้ inline-flex เพื่อให้ปรับขนาดตามเนื้อหา
                        alignItems: 'center',
                        boxSizing: 'border-box',
                        textAlign: 'left',
                        marginLeft: '0', 
                        marginBottom:'20px'
                    }}>
                        <div style={{
                            border: '1px solid #dddddd',
                            borderRadius: '1000px',
                            padding: '2px 12px',
                            display: 'flex',
                            gap: '8px',
                            background:'white',
                            fontSize:'0.9vw'
                        }}>
                                <p>{getNameSubjectMetadata(courseDetails.course?.subject)}</p>
                                <p><FontAwesomeIcon icon={faChevronRight} /></p>
                                <p> {currentActiveTab === 'Detail' ? 'รายละเอียดรายวิชา' :
                                    currentActiveTab === 'videos' ? 'วิดีโอย้อนหลัง' :
                                    currentActiveTab === 'documents' ? 'เอกสาร' :
                                    currentActiveTab === 'tests' ? 'แบบทดสอบ' :
                                    currentActiveTab === 'homeworks' ? 'การบ้าน' :
                                    currentActiveTab === 'specialscore' ? 'คะแนนพิเศษ' :
                                    currentActiveTab === 'comments' ? 'ถาม-ตอบ' :
                                    currentActiveTab === 'others' ? 'แบบประเมิน' :
                                    currentActiveTab === 'account_courses' ? 'เพื่อนร่วมหลักสูตร' :
                                    currentActiveTab}
                                </p>
                        </div>
                    </div>
                ) : (
                null
                )}
                    <div className="tabs"
                        style={{
                            display: 'flex',
                            flexWrap: 'nowrap',
                            overflowX: 'auto',
                            whiteSpace: 'nowrap',
                            width: '100%',
                            boxShadow: '0px 4px 42px 0px #00000040',
                            justifyContent: 'space-between',
                            textAlign: 'center',
                            borderRadius: '1000px',
                            border: '0.5px solid #44526E',
                            backgroundColor:'#44526E',
                        }}
                    >
                        <button
                            className={`tab-button ${currentActiveTab  === 'Detail' ? 'active' : ''}`}
                            onClick={() => handleTabChange('Detail')}
                            style={{
                                backgroundColor: currentActiveTab === 'Detail' ? '#44526E' : '#FFFFFF', 
                                color: currentActiveTab === 'Detail' ? '#FFFFFF' : '#44526E', 
                                border: '1px solid #44526E',
                                padding: '10px 20px',
                                cursor: 'pointer',
                                flex: 1,
                                textAlign: 'center',
                                fontSize: '1.4vw',
                                borderTopLeftRadius: '1000px',
                                borderBottomLeftRadius: '1000px',
                            }}
                        >
                            รายละเอียดรายวิชา
                        </button>
                        <button
                            className={`tab-button ${currentActiveTab === 'videos' ? 'active' : ''}`}
                            onClick={() => handleTabChange('videos')}
                            style={{
                                backgroundColor: currentActiveTab === 'videos' ? '#44526E' : '#FFFFFF', 
                                color: currentActiveTab === 'videos' ? '#FFFFFF' : '#44526E', 
                                border: '1px solid #44526E',
                                padding: '10px 20px',
                                cursor: 'pointer',
                                flex: 1,
                                textAlign: 'center',
                                fontSize: '1.4vw',
                            }}
                        >
                            วิดีโอย้อนหลัง
                        </button>
                        <button
                            className={`tab-button ${currentActiveTab  === 'documents' ? 'active' : ''}`}
                            onClick={() => handleTabChange('documents')}
                            style={{
                                backgroundColor: currentActiveTab === 'documents' ? '#44526E' : '#FFFFFF', 
                                color: currentActiveTab === 'documents' ? '#FFFFFF' : '#44526E', 
                                border: '1px solid #44526E',
                                padding: '10px 20px',
                                cursor: 'pointer',
                                flex: 1,
                                textAlign: 'center',
                                fontSize: '1.4vw',
                                bordertopRadius:'1000px'
                            }}
                        >
                            เอกสาร
                        </button>
                        <button
                            className={`tab-button ${currentActiveTab  === 'tests' ? 'active' : ''}`}
                            onClick={() => handleTabChange('tests')}
                            style={{
                                backgroundColor: currentActiveTab === 'tests' ? '#44526E' : '#FFFFFF', 
                                color: currentActiveTab === 'tests' ? '#FFFFFF' : '#44526E', 
                                border: '1px solid #44526E',
                                padding: '10px 20px',
                                cursor: 'pointer',
                                flex: 1,
                                textAlign: 'center',
                                fontSize: '1.4vw',
                            }}
                        >
                            แบบทดสอบ
                        </button>
                        <button
                            className={`tab-button ${currentActiveTab  === 'homeworks' ? 'active' : ''}`}
                            onClick={() => handleTabChange('homeworks')}
                            style={{
                                backgroundColor: currentActiveTab === 'homeworks' ? '#44526E' : '#FFFFFF', 
                                color: currentActiveTab === 'homeworks' ? '#FFFFFF' : '#44526E', 
                                border: '1px solid #44526E',
                                padding: '10px 20px',
                                cursor: 'pointer',
                                flex: 1,
                                textAlign: 'center',
                                fontSize: '1.4vw',
                                
                            }}
                        >
                            การบ้าน
                        </button>
                        <button
                            className={`tab-button ${currentActiveTab  === 'specialscore' ? 'active' : ''}`}
                            onClick={() => handleTabChange('specialscore')}
                            style={{
                                backgroundColor: currentActiveTab === 'specialscore' ? '#44526E' : '#FFFFFF', 
                                color: currentActiveTab === 'specialscore' ? '#FFFFFF' : '#44526E', 
                                border: '1px solid #44526E',
                                padding: '10px 20px',
                                cursor: 'pointer',
                                flex: 1,
                                textAlign: 'center',
                                fontSize: '1.4vw',
                                
                            }}
                        >
                            คะแนนพิเศษ
                        </button>
                        <button
                            className={`tab-button ${currentActiveTab  === 'comments' ? 'active' : ''}`}
                            onClick={() => handleTabChange('comments')}
                            style={{
                                backgroundColor: currentActiveTab === 'comments' ? '#44526E' : '#FFFFFF', 
                                color: currentActiveTab === 'comments' ? '#FFFFFF' : '#44526E', 
                                border: '1px solid #44526E',
                                padding: '10px 20px',
                                cursor: 'pointer',
                                flex: 1,
                                textAlign: 'center',
                                fontSize: '1.4vw',
                                
                            }}
                        >
                            ถาม-ตอบ
                        </button>
                        <button
                            className={`tab-button ${currentActiveTab  === 'others' ? 'active' : ''}`}
                            onClick={() => handleTabChange('others')}
                            style={{
                                backgroundColor: currentActiveTab === 'others' ? '#44526E' : '#FFFFFF', 
                                color: currentActiveTab === 'others' ? '#FFFFFF' : '#44526E', 
                                border: '1px solid #44526E',
                                padding: '10px 20px',
                                cursor: 'pointer',
                                flex: 1,
                                textAlign: 'center',
                                fontSize: '1.4vw',
                            }}
                        >
                            แบบประเมิน
                        </button>
                        <button
                            className={`tab-button ${currentActiveTab  === 'account_courses' ? 'active' : ''}`}
                            onClick={() => handleTabChange('account_courses')}
                            style={{
                                backgroundColor: currentActiveTab === 'account_courses' ? '#44526E' : '#FFFFFF', 
                                color: currentActiveTab === 'account_courses' ? '#FFFFFF' : '#44526E', 
                                border: '1px solid #44526E',
                                padding: '10px 20px',
                                cursor: 'pointer',
                                flex: 1,
                                textAlign: 'center',
                                fontSize: '1.4vw',
                                borderTopRightRadius: '1000px',
                                borderBottomRightRadius: '1000px',
                            }}
                        >
                            เพื่อนร่วมหลักสูตร
                        </button>
                    </div>
                    <div className="tab-content" 
                        style={{
                            height:'auto',
                            boxSizing:'border-box',
                            margin:'24px 0'
                    }}>
                         {currentActiveTab === 'Detail' && (
                            <div id="Detail-list" >
                                {courseDetails ? (
                                
                                <div style={styles.detailCourse}>
                                    <div style={styles.left}>
                                    <div style={{display:'flex',gap:'24px',color: '#44526E'}}>
                                        <p>รุ่นที่ {getNameGenerationMetadata(courseDetails.course?.generation)}</p>
                                        <p>ปีการศึกษา {getNameYearMetadata(courseDetails.course?.year)}</p>
                                    </div>
                                        <p  style={{
                                                fontSize: '32px',
                                                color:'#44526E',
                                                marginTop:'0px',
                                                marginBottom:'0px',
                                                fontWeight:'bold'
                                        }}>{getNameSubjectMetadata(courseDetails.course?.subject)}</p>
                                         <p style={{color: '#44526E'}}>หลักสูตร : {getNameCourseNameMetadata(courseDetails.course?.name)}</p>
                                         <p style={{color: '#44526E'}}>หมวดวิชา : {getNameCagegoryMetadata(courseDetails.course?.category)}</p>           
                                        <div style={{ margin: '10px 0',display:'flex' ,alignItems: 'center', gap:'16px'}}>
                                            <div style={styles.progressContainer}>
                                                <div style={{ ...styles.progressBar, width: `${courseDetails.course?.learn_percent}%` }}></div>
                                            </div>
                                            <p style={{color:'#44526E'}}>สำเร็จ {Math.floor(courseDetails.course?.learn_percent)} / 100%</p>
                                        </div>
                                        <div style={styles.teacherDateTime}>
                                            <div style={styles.Detaildatteachtime}>
                                                <FontAwesomeIcon icon={faUser} style={{ color: '#44526e' , fontSize:'1.5vw'}} />
                                                <p style={{ margin: '0 auto' }}>{courseDetails.course?.teacher}</p>
                                            </div>
                                            <div style={styles.Detaildatteachtime}>
                                                <FontAwesomeIcon icon={faCalendar} style={{ color: '#44526e' , fontSize:'1.5vw'}} />
                                                <p style={{ margin: '0 auto' }}>
                                                {courseDetails.course ? convertToThaiDate(courseDetails.course.date) : 'ไม่ระบุวันที่'}
                                                </p>
                                            </div>
                                            <div style={styles.Detaildatteachtime}>
                                                <FontAwesomeIcon icon={faClock} style={{ color: '#44526e' , fontSize:'1.5vw'}} />
                                                <p style={{ margin: '0 auto' }}>{convertTimeFormat(courseDetails.course?.time)}</p>
                                            </div>
                                        </div>
                                                
                                                <div style={{fontSize:'24px'}}>
                                                    <p style={{marginTop:'0',color:'#44526E' }}><strong>ขอบเขตการเรียนการสอน</strong></p>
                                                    <p style={{marginTop:'0'}}>{courseDetails.course?.description}</p>
                                                </div>
                                                <div style={{fontSize:'24px'}}>
                                                    <p style={{marginTop:'0',color:'#44526E'}}><strong>วัตถุประสงค์รายวิชา</strong></p>
                                                    <p style={{marginTop:'0'}}>{courseDetails.course?.objective}</p>
                                                </div>
                                    </div>
                                    {isAdmin && (
              <div style={styles.rightScore}>
                <div style={styles.allScore}>
                  <p style={{ color: '#44526e', fontWeight: 'bold', fontSize: '1vw', margin: 0 }}>คะแนนรายวิชา</p>
                  <hr />
                  <div style={{ padding: '0px 16px' }}>
                    {courseDetails.user?.tests?.length > 0 && (
                      <div>
                        <p style={{ fontWeight: 'bold', fontSize: '1vw' }}>แบบทดสอบ</p>
                        {courseDetails.user.tests.map((test, index) => (
                          <div key={index} style={{ marginLeft: '20px', marginBottom: '10px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              {test.chapter ? (
                                <li style={{ fontSize: '1vw' }}>{test.chapter}</li>
                              ) : (
                                <li>ยังไม่มีคะแนนในส่วนนี้</li>
                              )}
                              <div>
                                <span
                                  style={{
                                    color: test.total_score === null ? 'black' : '#44526e',
                                    fontWeight: test.total_score === null ? 'none' : 'bold',
                                    fontSize: '1vw',
                                  }}
                                >
                                  {test.total_score === null ? '-' : test.total_score}
                                </span>
                                {' / '}
                                <span style={{ color: test.max_score === null ? 'black' : 'black', fontSize: '1vw' }}>
                                  {test.max_score === null ? '-' : test.max_score}
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    {courseDetails.user?.homeworks?.length > 0 && (
                      <div>
                        <p style={{ fontWeight: 'bold', fontSize: '1vw' }}>การบ้าน</p>
                        {courseDetails.user.homeworks.map((homework, index) => (
                          <div key={index} style={{ marginLeft: '20px', marginBottom: '10px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              {homework.chapter ? (
                                <li style={{ fontSize: '1vw' }}>{homework.chapter}</li>
                              ) : (
                                <li>ยังไม่มีคะแนนในส่วนนี้</li>
                              )}
                              <div>
                                <span
                                  style={{
                                    color: homework.total_score === null ? 'black' : '#44526e',
                                    fontWeight: homework.total_score === null ? 'none' : 'bold',
                                    fontSize: '1vw',
                                  }}
                                >
                                  {homework.total_score === null ? '-' : homework.total_score}
                                </span>
                                {' / '}
                                <span
                                  style={{ color: homework.max_score === null ? 'black' : 'black', fontSize: '1vw' }}
                                >
                                  {homework.max_score === null ? '-' : homework.max_score}
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    {courseDetails.user?.specials?.length > 0 && (
                      <div>
                        <p style={{ fontWeight: 'bold', fontSize: '1vw' }}>คะแนนพิเศษ</p>
                        {courseDetails.user.specials.map((special, index) => (
                          <div key={index} style={{ marginLeft: '20px', marginBottom: '10px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              {special.chapter ? (
                                <li style={{ fontSize: '1vw' }}>{special.chapter}</li>
                              ) : (
                                <li>ยังไม่มีคะแนนในส่วนนี้</li>
                              )}
                              <div>
                                <span
                                  style={{
                                    color: special.total_score === null ? 'black' : '#44526e',
                                    fontWeight: special.total_score === null ? 'none' : 'bold',
                                    fontSize: '1vw',
                                  }}
                                >
                                  {special.total_score === null ? '-' : special.total_score}
                                </span>
                                {' / '}
                                <span
                                  style={{ color: special.max_score === null ? 'black' : 'black', fontSize: '1vw' }}
                                >
                                  {special.max_score === null ? '-' : special.max_score}
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div style={{ borderTop: '1px solid #ccc' }}>
                    <p
                      style={{
                        textAlign: 'right',
                        paddingRight: '10px',
                        fontWeight: 'bold',
                        color: '#218730',
                        fontSize: '1.3vw',
                        margin: '0',
                      }}
                    >
                      {courseDetails.user.total_score}
                    </p>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span style={{ fontSize: '1vw' }}>คะแนนรวม</span>
                      <span style={{ fontSize: '1vw' }}>/ {courseDetails.user.max_score}</span>
                    </div>
                  </div>
                </div>
                <button 
                                        onClick={() => ShowScoreAll(
                                            courseDetails.course?.name, 
                                            courseDetails.course?.category,
                                            courseDetails.course?.generation, 
                                            1 // PopupType = 1 สำหรับ popup1
                                        )} 
                                        style={styles.btnScore}
                                        >
                                        <p style={{fontWeight:'bold',fontSize:'1vw'}}>คะแนนหลักสูตร</p>
                                        </button>
                                        <button 
                                        onClick={() => ShowScoreAll(
                                            courseDetails.course?.name, 
                                            courseDetails.course?.category,
                                            courseDetails.course?.generation, 
                                            2 // PopupType = 1 สำหรับ popup1
                                        )} 
                                        style={styles.btnScore}
                                        >
                                        <p style={{fontWeight:'bold',fontSize:'1vw'}}>คะแนนหมวดวิชา</p>
                                        </button>
              </div>
            )}                                </div>
                                    ) : (
                                    <p>Loading course details...</p>
                                )}
                            </div>  
                        )}      
                        {currentActiveTab === 'videos' && (
                            <VideosTab
                                courseDetails={courseDetails}
                                currentVideoIndex={currentVideoIndex}
                                handleVideoClick={handleVideoClick}
                            />
                        )}
                        {courseDetails && currentActiveTab === 'documents' && (
                            <DocumentList
                                documents={courseDetails.documents}
                                downloadedFiles={downloadedFiles}
                                handleDownload={handleDownload}
                            />
                        )}
                        {courseDetails && currentActiveTab === 'tests' && (
                            <TestList
                                tests={courseDetails.tests}
                                handleTestClick={handleTestClick}
                            />
                        )}
                        {currentActiveTab === 'comments' && (
                            <CommentsTab
                                courseDetails={courseDetails}
                                user={user}
                                handleCreateComment={handleCreateComment}
                                handleCommentChange={handleCommentChange}
                                newComment={newComment}
                                replyMessage={replyMessage}
                                handleReplySubmit={handleReplySubmit}
                                handleReplyChange={handleReplyChange}
                                toggleReply={toggleReply}
                                replyToCommentUid={replyToCommentUid}
                            />
                        )}                       
                        {currentActiveTab === 'homeworks' && (
                            <HomeworksTab
                                courseDetails={courseDetails}
                                downloadedFiles={downloadedFiles}
                                handleDownload={handleDownload}
                                handleUpload={handleUpload}
                                isHomeworkExpired={isHomeworkExpired}
                                fileInputRef={fileInputRef}
                            />
                        )}
                        {currentActiveTab === 'specialscore' && (
                            <SpecialScoreTab
                                courseDetails={courseDetails}
                                downloadedFiles={downloadedFiles}
                                handleDownload={handleDownload}
                                handleUploadScore={handleUploadScore}
                                fileInputRef={fileInputRef}
                            />
                        )}
                        {currentActiveTab === 'others' && (
                            <SurveyTab
                                courseDetails={courseDetails}
                                handleChapterClick={handleChapterClick}
                            />
                        )}           
                        {currentActiveTab === 'account_courses' && (
                            <AccountCoursesTab courseDetails={courseDetails} />
                        )} 

                    </div>
                </div>
            </div>
            {isPopup1Open && (
    <div style={styles.modalStyles}>
        <div style={styles.modalContentStyles}>
            <div>
                {coursesData?.map((course, courseIndex) => (
                    <div key={courseIndex}>
                        <div style={styles.headerScorePopup}>
                            <h3 style={styles.headText}>{getNameCourseNameMetadata(course.name)}</h3>
                            <img src={close} alt="close" style={styles.closeBtn} onClick={closePopup} />
                        </div>
                        {course.categorys?.map((category, categoryIndex) => (
                            <div key={categoryIndex}>
                                <div style={styles.tableStyle}>
                                    <table style={{
                                        width: "100%",
                                        textAlign: "left",
                                        borderCollapse: "separate",
                                        borderSpacing: "0px 4px",
                                        borderRadius: "10px",
                                        overflow: "hidden"
                                    }}>
                                        {/* Thead ส่วนกลาง */}
                                        <thead>
                                            <tr style={styles.thrStyle}>
                                                <th style={styles.thStyle}>หมวดวิชา</th>
                                                <th style={styles.thStyle}>แบบทดสอบ</th>
                                                <th style={styles.thStyle}>การบ้าน</th>
                                                <th style={styles.thStyle}>คะแนนพิเศษ</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* สร้าง tbody แยกสำหรับ subjects */}
                                            {category.subjects?.map((subject, subjectIndex) => (
                                                <tr
                                                    key={subjectIndex}
                                                    style={{
                                                        ...styles.tdrStyle,
                                                        backgroundColor: subjectIndex % 2 === 0 ? '#f5f5f5' : 'white'
                                                    }}
                                                >
                                                    <td style={styles.tdStyle}>{getNameSubjectMetadata(category?.category)}</td>
                                                    <td style={styles.tdStyleNumber}>
                                                        <span style={{ fontWeight: 'bold' }}>
                                                            {subject.test_total_score_sum === 0 && subject.test_max_score_sum === 0
                                                                ? "-"
                                                                : subject.test_total_score_sum}
                                                        </span>
                                                        {' / '}
                                                        <span>
                                                            {subject.test_max_score_sum === 0 && subject.test_max_score_sum === 0
                                                                ? "-"
                                                                : subject.test_max_score_sum}
                                                        </span>
                                                    </td>
                                                    <td style={styles.tdStyleNumber}>
                                                        <span style={{ fontWeight: 'bold' }}>
                                                            {subject.homework_total_score_sum === 0 && subject.homework_max_score_sum === 0
                                                                ? "-"
                                                                : subject.homework_total_score_sum}
                                                        </span>
                                                        {' / '}
                                                        <span>
                                                            {subject.homework_max_score_sum === 0 && subject.homework_max_score_sum === 0
                                                                ? "-"
                                                                : subject.homework_max_score_sum}
                                                        </span>
                                                    </td>
                                                    <td style={styles.tdStyleNumber}>
                                                        <span style={{ fontWeight: 'bold' }}>
                                                            {subject.special_total_score_sum === 0 && subject.special_max_score_sum === 0
                                                                ? "-"
                                                                : subject.special_total_score_sum}
                                                        </span>
                                                        {' / '}
                                                        <span>
                                                            {subject.special_max_score_sum === 0 && subject.special_max_score_sum === 0
                                                                ? "-"
                                                                : subject.special_max_score_sum}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    </div>
)}

{isPopup2Open && (
    <div style={styles.modalStyles}>
        <div style={styles.modalContentStyles}>
            <div>
                {coursesData?.map((course, courseIndex) => (
                    <div key={courseIndex}>
                        <div style={styles.headerScorePopup}>
                            <h3 style={styles.headText}> {getNameCagegoryMetadata(course.name)}</h3>
                            <img src={close} alt="close" style={styles.closeBtn} onClick={closePopup} />
                        </div>
                        {course.categorys?.map((category, categoryIndex) => (
                            <div key={categoryIndex}>
                                {category.subjects?.map((subject, subjectIndex) => (
                                    <div key={subjectIndex} style={styles.tableStyle}>
                                        <table
                                            style={{
                                                width: "100%",
                                                textAlign: "left",
                                                borderCollapse: "separate", // ต้องใช้ "separate" เพื่อให้รองรับ borderRadius
                                                borderSpacing: "0px 4px", // ลบช่องว่างระหว่างเซลล์
                                                borderRadius: "10px", // มุมโค้ง
                                                overflow: "hidden" // เพื่อให้เซลล์อยู่ในขอบโค้ง
                                            }}
                                        >
                                            {/* แสดง thead ขึ้นแค่ครั้งเดียว */}
                                            {subjectIndex === 0 && (
                                                <thead>
                                                    <tr style={styles.thrStyle}>
                                                        <th style={styles.thStyle}>รายวิชา</th>
                                                        <th style={styles.thStyle}>แบบทดสอบ</th>
                                                        <th style={styles.thStyle}>การบ้าน</th>
                                                        <th style={styles.thStyle}>คะแนนพิเศษ</th>
                                                    </tr>
                                                </thead>
                                            )}
                                            <tbody>
                                                <tr
                                                    style={{
                                                        ...styles.tdrStyle,
                                                        backgroundColor: subjectIndex % 2 === 0 ? "#f5f5f5" : "white"
                                                    }}
                                                >
                                                    <td style={styles.tdStyle}>
                                                        {getNameSubjectMetadata(subject?.subject)}
                                                    </td>
                                                    <td style={styles.tdStyleNumber}>
                                                        <span style={{ fontWeight: "bold" }}>
                                                            {subject.test_total_score_sum === 0 && subject.test_max_score_sum === 0
                                                                ? "-"
                                                                : subject.test_total_score_sum}
                                                        </span>
                                                        {" / "}
                                                        <span>
                                                            {subject.test_max_score_sum === 0 && subject.test_max_score_sum === 0
                                                                ? "-"
                                                                : subject.test_max_score_sum}
                                                        </span>
                                                    </td>
                                                    <td style={styles.tdStyleNumber}>
                                                        <span style={{ fontWeight: "bold" }}>
                                                            {subject.homework_total_score_sum === 0 && subject.homework_max_score_sum === 0
                                                                ? "-"
                                                                : subject.homework_total_score_sum}
                                                        </span>
                                                        {" / "}
                                                        <span>
                                                            {subject.homework_max_score_sum === 0 && subject.homework_max_score_sum === 0
                                                                ? "-"
                                                                : subject.homework_max_score_sum}
                                                        </span>
                                                    </td>
                                                    <td style={styles.tdStyleNumber}>
                                                        <span style={{ fontWeight: "bold" }}>
                                                            {subject.special_total_score_sum === 0 && subject.special_max_score_sum === 0
                                                                ? "-"
                                                                : subject.special_total_score_sum}
                                                        </span>
                                                        {" / "}
                                                        <span>
                                                            {subject.special_max_score_sum === 0 && subject.special_max_score_sum === 0
                                                                ? "-"
                                                                : subject.special_max_score_sum}
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    </div>
)}


        </main> 
    </>
    );
    
};

export default CoursePage;
